'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dRecipe$002dSort$002dType from "./mealorama.-Recipe-Sort-Type.js";
import * as $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241 from "./mealorama.-Recipe-Sort-Type$$anon$1.js";
var $p;
function $s_Lmealorama_RecipeSortType$__title__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__title;
}
export { $s_Lmealorama_RecipeSortType$__title__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__title__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__cuisine__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__cuisine;
}
export { $s_Lmealorama_RecipeSortType$__cuisine__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__cuisine__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__course__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__course;
}
export { $s_Lmealorama_RecipeSortType$__course__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__course__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__lastMade__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__lastMade;
}
export { $s_Lmealorama_RecipeSortType$__lastMade__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__lastMade__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__rating__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__rating;
}
export { $s_Lmealorama_RecipeSortType$__rating__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__rating__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__importState__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__importState;
}
export { $s_Lmealorama_RecipeSortType$__importState__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__importState__Lmealorama_RecipeSortType };
function $s_Lmealorama_RecipeSortType$__createdDate__Lmealorama_RecipeSortType() {
  $m_Lmealorama_RecipeSortType$();
  return $t_Lmealorama_RecipeSortType$__createdDate;
}
export { $s_Lmealorama_RecipeSortType$__createdDate__Lmealorama_RecipeSortType as $s_Lmealorama_RecipeSortType$__createdDate__Lmealorama_RecipeSortType };
/** @constructor */
function $c_Lmealorama_RecipeSortType$() {
  this.am1 = null;
  $n_Lmealorama_RecipeSortType$ = this;
  $t_Lmealorama_RecipeSortType$__title = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("title", 0);
  $t_Lmealorama_RecipeSortType$__cuisine = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("cuisine", 1);
  $t_Lmealorama_RecipeSortType$__course = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("course", 2);
  $t_Lmealorama_RecipeSortType$__lastMade = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("lastMade", 3);
  $t_Lmealorama_RecipeSortType$__rating = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("rating", 4);
  $t_Lmealorama_RecipeSortType$__importState = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("importState", 5);
  $t_Lmealorama_RecipeSortType$__createdDate = new $j_mealorama$002e$002dRecipe$002dSort$002dType$0024$0024anon$00241.$c_Lmealorama_RecipeSortType$$anon$1("createdDate", 6);
  this.am1 = new ($j_mealorama$002e$002dRecipe$002dSort$002dType.$d_Lmealorama_RecipeSortType.r().C)([$s_Lmealorama_RecipeSortType$__title__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__cuisine__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__course__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__lastMade__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__rating__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__importState__Lmealorama_RecipeSortType(), $s_Lmealorama_RecipeSortType$__createdDate__Lmealorama_RecipeSortType()]);
}
export { $c_Lmealorama_RecipeSortType$ as $c_Lmealorama_RecipeSortType$ };
$p = $c_Lmealorama_RecipeSortType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSortType$;
/** @constructor */
function $h_Lmealorama_RecipeSortType$() {
}
export { $h_Lmealorama_RecipeSortType$ as $h_Lmealorama_RecipeSortType$ };
$h_Lmealorama_RecipeSortType$.prototype = $p;
$p.b6v = (function() {
  return this.am1.a6();
});
var $d_Lmealorama_RecipeSortType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeSortType$, "mealorama.RecipeSortType$", ({
  GP: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_RecipeSortType$ as $d_Lmealorama_RecipeSortType$ };
var $n_Lmealorama_RecipeSortType$;
function $m_Lmealorama_RecipeSortType$() {
  if ((!$n_Lmealorama_RecipeSortType$)) {
    $n_Lmealorama_RecipeSortType$ = new $c_Lmealorama_RecipeSortType$();
  }
  return $n_Lmealorama_RecipeSortType$;
}
export { $m_Lmealorama_RecipeSortType$ as $m_Lmealorama_RecipeSortType$ };
var $t_Lmealorama_RecipeSortType$__title = null;
function $u_Lmealorama_RecipeSortType$__title(x) {
  $t_Lmealorama_RecipeSortType$__title = x;
}
export { $t_Lmealorama_RecipeSortType$__title as $t_Lmealorama_RecipeSortType$__title, $u_Lmealorama_RecipeSortType$__title as $u_Lmealorama_RecipeSortType$__title };
var $t_Lmealorama_RecipeSortType$__cuisine = null;
function $u_Lmealorama_RecipeSortType$__cuisine(x) {
  $t_Lmealorama_RecipeSortType$__cuisine = x;
}
export { $t_Lmealorama_RecipeSortType$__cuisine as $t_Lmealorama_RecipeSortType$__cuisine, $u_Lmealorama_RecipeSortType$__cuisine as $u_Lmealorama_RecipeSortType$__cuisine };
var $t_Lmealorama_RecipeSortType$__course = null;
function $u_Lmealorama_RecipeSortType$__course(x) {
  $t_Lmealorama_RecipeSortType$__course = x;
}
export { $t_Lmealorama_RecipeSortType$__course as $t_Lmealorama_RecipeSortType$__course, $u_Lmealorama_RecipeSortType$__course as $u_Lmealorama_RecipeSortType$__course };
var $t_Lmealorama_RecipeSortType$__lastMade = null;
function $u_Lmealorama_RecipeSortType$__lastMade(x) {
  $t_Lmealorama_RecipeSortType$__lastMade = x;
}
export { $t_Lmealorama_RecipeSortType$__lastMade as $t_Lmealorama_RecipeSortType$__lastMade, $u_Lmealorama_RecipeSortType$__lastMade as $u_Lmealorama_RecipeSortType$__lastMade };
var $t_Lmealorama_RecipeSortType$__rating = null;
function $u_Lmealorama_RecipeSortType$__rating(x) {
  $t_Lmealorama_RecipeSortType$__rating = x;
}
export { $t_Lmealorama_RecipeSortType$__rating as $t_Lmealorama_RecipeSortType$__rating, $u_Lmealorama_RecipeSortType$__rating as $u_Lmealorama_RecipeSortType$__rating };
var $t_Lmealorama_RecipeSortType$__importState = null;
function $u_Lmealorama_RecipeSortType$__importState(x) {
  $t_Lmealorama_RecipeSortType$__importState = x;
}
export { $t_Lmealorama_RecipeSortType$__importState as $t_Lmealorama_RecipeSortType$__importState, $u_Lmealorama_RecipeSortType$__importState as $u_Lmealorama_RecipeSortType$__importState };
var $t_Lmealorama_RecipeSortType$__createdDate = null;
function $u_Lmealorama_RecipeSortType$__createdDate(x) {
  $t_Lmealorama_RecipeSortType$__createdDate = x;
}
export { $t_Lmealorama_RecipeSortType$__createdDate as $t_Lmealorama_RecipeSortType$__createdDate, $u_Lmealorama_RecipeSortType$__createdDate as $u_Lmealorama_RecipeSortType$__createdDate };
//# sourceMappingURL=mealorama.-Recipe-Sort-Type$.js.map
